import { render } from "./VirtualProductForm.vue?vue&type=template&id=38117732"
import script from "./VirtualProductForm.vue?vue&type=script&lang=js"
export * from "./VirtualProductForm.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./VirtualProductForm.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36ffa97d%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fpos%2Fsubscription%2Fformwithsteps%2FVirtualProductForm.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__